export const CLIENT = 'CLIENT';
export const CLIENT_ALL = `${CLIENT}/ALL`;
export const CLIENT_SEARCH = `${CLIENT}/SEARCH`;
export const CLIENT_DELETE = `${CLIENT}/DELETE`;
export const CLIENT_VIEW = `${CLIENT}/VIEW`;
